import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import PopoverItem from '../../Popover/PopoverItem/PopoverItem';
import Tooltip from '../../Tooltip/Tooltip';

const MassActionButton = ({
  checkedRows,
  handleClick,
  buttonMessage,
  icon,
  disabled = false,
  actionDisallowed,
  color,
  testId,
}) => {
  const { t } = useTranslation();
  const actionDisabled =
    disabled || checkedRows.length > 100 || actionDisallowed;

  return (
    <Tooltip
      tooltip={actionDisallowed ? t('UserRoles.CannotPerformAction') : ''}
      tooltipPlacement="rightCenter"
      phoneTooltipPlacement="rightCenter"
    >
      <PopoverItem
        buttonSize="sm"
        iconImage={icon}
        onClick={handleClick}
        buttonColor="borderless"
        iconPosition="start"
        color={color}
        disabled={actionDisabled}
        additionalClasses={twMerge(
          actionDisabled &&
            'bg-transparent hover:bg-transparent active:bg-transparent opacity-50 ',
        )}
        label={buttonMessage}
        testId={testId}
      />
    </Tooltip>
  );
};

export default MassActionButton;

MassActionButton.propTypes = {
  /**
   * Array of checked rows
   */
  checkedRows: PropTypes.array,
  /**
   * Handle click callback
   */
  handleClick: PropTypes.func,
  /**
   * Button message
   */
  buttonMessage: PropTypes.string,
  /**
   * Button color
   */
  color: PropTypes.oneOf(['red', 'blue', 'green']),
  /**
   * Button icon
   */
  icon: PropTypes.node,
  /**
   * is disabled
   */
  disabled: PropTypes.bool,
  /**
   * testid
   */
  testId: PropTypes.string,
};
